import { PricePermissions, UserV2 } from '@obeta/models/lib/models/Users/UserV2'

export const hasReadPricePermission = (user: UserV2 | null) => {
  return user?.permissions?.Global_canReadPrices === PricePermissions.PurchasePrice
}
